import { isArrayEmpty } from "../../../../../../shared/utils/array";
import { GenericProps } from "../../types";
import { AppPermissions } from "./AppPermissions";
import { HeaderRow } from "./HeaderRow";
import { useMemberUsers } from "./hooks";

export function Permissions(props: GenericProps) {

    const { state, dispatch } = props

    const { userId, ownerRole } = state.loggedInUser
    const readOnly = !ownerRole

    const users = useMemberUsers(state.users, state.filters.users)
    const members = users.visible

    if (isArrayEmpty(users.all)) {

        return <div style={{ margin: "3rem 1rem" }}>

            <p>
                There are no users with the 'member' role registered on this holding.
            </p>

            {
                ownerRole &&
                <p>
                    You can invite new users from the 'Invitations' tab. Once they have accepted your invitation, you will be able to manage their permissions.
                </p>
            }


        </div>

    }

    return <div className="permissions">

        <div className="grid-container">

            <div className="grid">

                <HeaderRow {...props} users={members} />

                <AppPermissions dispatch={dispatch} users={members} app="hub" readOnly={readOnly} currentUserId={userId} />
                <AppPermissions dispatch={dispatch} users={members} app="scout" readOnly={readOnly} currentUserId={userId} />

            </div>


        </div>

    </div>


}
